import React from 'react';
import Preloader from '../helper/Preloader';
import HeaderOne from '../components/HeaderOne';
import Breadcrumb from '../components/Breadcrumb';
import FooterOne from '../components/FooterOne';
import BottomFooter from '../components/BottomFooter';
import ColorInit from '../helper/ColorInit';
import ForgotPasswordSection from '../components/ForgotPasswordSection';

const ForgotPasswordPage = () => {
    return (
        <>
            {/* ColorInit */}
            <ColorInit color={false} />

            {/* Preloader */}
            <Preloader />

            {/* HeaderOne */}
            <HeaderOne />

            {/* Breadcrumb */}
            <Breadcrumb title="Forgot Password" />

            {/* Forgot Password Section */}
            <ForgotPasswordSection />

            {/* FooterOne */}
            <FooterOne />

            {/* BottomFooter */}
            <BottomFooter />
        </>
    );
};

export default ForgotPasswordPage;
